import React from 'react';
import styles from '../../styles/LoginRegister.module.css';

interface PasswordToggleButtonProps {
  visible: boolean;
  onClick: () => void;
}

// Inline SVG (not emoji) so the icon inherits currentColor and lines up
// pixel-perfectly inside the button — emoji glyphs render with their own
// fixed colors and inconsistent baselines across platforms/fonts.
const PasswordToggleButton: React.FC<PasswordToggleButtonProps> = ({ visible, onClick }) => (
  <button
    type="button"
    className={styles.passwordToggleBtn}
    onClick={onClick}
    aria-label={visible ? 'Hide password' : 'Show password'}
  >
    {visible ? (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
    ) : (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    )}
  </button>
);

export default PasswordToggleButton;